export default __webpack_public_path__ + "static/media/banner_mob.31ccc3bf.mp4";